import React from "react";
import {Typography} from "@mui/material";

import {buildHealthIndicatorIcon, buildSessionHealthColor} from "../../../helpers/HealthIndicatorBuilder";
import {CenteredBox, ColoredAvatar} from "../../themes/styled";

export default function DefaultHealth({session, state}) {

    const backgroundColor = buildSessionHealthColor[state];
    const icon = buildHealthIndicatorIcon("default");

    return (
      <CenteredBox>
          <ColoredAvatar background={backgroundColor}>{icon}</ColoredAvatar>
          <Typography variant="body2">Unknown</Typography>
      </CenteredBox>
    );
}